// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/httpv2/maas.proto (package infinigence.infini.agentplatform.httpv2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ListRequestSchema } from "./common_pb.js";
import { file_agentplatform_httpv2_common } from "./common_pb.js";
import type { MaasCredential, MaasModel } from "../v2/maas_pb.js";
import { file_agentplatform_v2_maas } from "../v2/maas_pb.js";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb.js";
import { file_gnostic_openapi_v3_annotations } from "../../gnostic/openapi/v3/annotations_pb.js";
import { file_google_api_annotations } from "../../google/api/annotations_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/httpv2/maas.proto.
 */
export const file_agentplatform_httpv2_maas: GenFile = /*@__PURE__*/
  fileDesc("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", [file_agentplatform_httpv2_common, file_agentplatform_v2_maas, file_buf_validate_validate, file_gnostic_openapi_v3_annotations, file_google_api_annotations]);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateMaasCredentialRequest
 */
export type CreateMaasCredentialRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateMaasCredentialRequest"> & {
  /**
   * 凭证名称 / Credential name
   * @gotags: json:"name"
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * API Key
   * @gotags: json:"api_key"
   *
   * @generated from field: string api_key = 2 [json_name = "api_key"];
   */
  apiKey: string;

  /**
   * 默认模型（可选）/ Default model (optional)
   * @gotags: json:"default_model,omitempty"
   *
   * @generated from field: string default_model = 3 [json_name = "default_model"];
   */
  defaultModel: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateMaasCredentialRequest.
 * Use `create(CreateMaasCredentialRequestSchema)` to create a new message.
 */
export const CreateMaasCredentialRequestSchema: GenMessage<CreateMaasCredentialRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_maas, 0);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateMaasCredentialResponse
 */
export type CreateMaasCredentialResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateMaasCredentialResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateMaasCredentialResponse.
 * Use `create(CreateMaasCredentialResponseSchema)` to create a new message.
 */
export const CreateMaasCredentialResponseSchema: GenMessage<CreateMaasCredentialResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_maas, 1);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetMaasCredentialRequest
 */
export type GetMaasCredentialRequest = Message<"infinigence.infini.agentplatform.httpv2.GetMaasCredentialRequest"> & {
  /**
   * 记录 ID / Record ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetMaasCredentialRequest.
 * Use `create(GetMaasCredentialRequestSchema)` to create a new message.
 */
export const GetMaasCredentialRequestSchema: GenMessage<GetMaasCredentialRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_maas, 2);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetMaasCredentialResponse
 */
export type GetMaasCredentialResponse = Message<"infinigence.infini.agentplatform.httpv2.GetMaasCredentialResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v2.MaasCredential data = 4;
   */
  data?: MaasCredential | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetMaasCredentialResponse.
 * Use `create(GetMaasCredentialResponseSchema)` to create a new message.
 */
export const GetMaasCredentialResponseSchema: GenMessage<GetMaasCredentialResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_maas, 3);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateMaasCredentialRequest
 */
export type UpdateMaasCredentialRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateMaasCredentialRequest"> & {
  /**
   * 记录 ID / Record ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 新名称（不修改时留空）/ New name (leave empty to keep current)
   * @gotags: json:"name,omitempty"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * API Key（不修改时留空）/ API Key (leave empty to keep current)
   * @gotags: json:"api_key,omitempty"
   *
   * @generated from field: string api_key = 4 [json_name = "api_key"];
   */
  apiKey: string;

  /**
   * 默认模型（不修改时留空）/ Default model (leave empty to keep current)
   * @gotags: json:"default_model,omitempty"
   *
   * @generated from field: string default_model = 5 [json_name = "default_model"];
   */
  defaultModel: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateMaasCredentialRequest.
 * Use `create(UpdateMaasCredentialRequestSchema)` to create a new message.
 */
export const UpdateMaasCredentialRequestSchema: GenMessage<UpdateMaasCredentialRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_maas, 4);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateMaasCredentialResponse
 */
export type UpdateMaasCredentialResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateMaasCredentialResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateMaasCredentialResponse.
 * Use `create(UpdateMaasCredentialResponseSchema)` to create a new message.
 */
export const UpdateMaasCredentialResponseSchema: GenMessage<UpdateMaasCredentialResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_maas, 5);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteMaasCredentialRequest
 */
export type DeleteMaasCredentialRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteMaasCredentialRequest"> & {
  /**
   * 记录 ID / Record ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteMaasCredentialRequest.
 * Use `create(DeleteMaasCredentialRequestSchema)` to create a new message.
 */
export const DeleteMaasCredentialRequestSchema: GenMessage<DeleteMaasCredentialRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_maas, 6);

/**
 * 删除响应无 data 字段 / Delete response has no data field
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteMaasCredentialResponse
 */
export type DeleteMaasCredentialResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteMaasCredentialResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteMaasCredentialResponse.
 * Use `create(DeleteMaasCredentialResponseSchema)` to create a new message.
 */
export const DeleteMaasCredentialResponseSchema: GenMessage<DeleteMaasCredentialResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_maas, 7);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListMaasCredentialsResponse
 */
export type ListMaasCredentialsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListMaasCredentialsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListMaasCredentialsData data = 4;
   */
  data?: ListMaasCredentialsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListMaasCredentialsResponse.
 * Use `create(ListMaasCredentialsResponseSchema)` to create a new message.
 */
export const ListMaasCredentialsResponseSchema: GenMessage<ListMaasCredentialsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_maas, 8);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListMaasCredentialsData
 */
export type ListMaasCredentialsData = Message<"infinigence.infini.agentplatform.httpv2.ListMaasCredentialsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v2.MaasCredential items = 1;
   */
  items: MaasCredential[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListMaasCredentialsData.
 * Use `create(ListMaasCredentialsDataSchema)` to create a new message.
 */
export const ListMaasCredentialsDataSchema: GenMessage<ListMaasCredentialsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_maas, 9);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListMaasCredentialModelsRequest
 */
export type ListMaasCredentialModelsRequest = Message<"infinigence.infini.agentplatform.httpv2.ListMaasCredentialModelsRequest"> & {
  /**
   * API Key
   * @gotags: json:"api_key"
   *
   * @generated from field: string api_key = 1 [json_name = "api_key"];
   */
  apiKey: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListMaasCredentialModelsRequest.
 * Use `create(ListMaasCredentialModelsRequestSchema)` to create a new message.
 */
export const ListMaasCredentialModelsRequestSchema: GenMessage<ListMaasCredentialModelsRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_maas, 10);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListMaasCredentialModelsResponse
 */
export type ListMaasCredentialModelsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListMaasCredentialModelsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListMaasCredentialModelsData data = 4;
   */
  data?: ListMaasCredentialModelsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListMaasCredentialModelsResponse.
 * Use `create(ListMaasCredentialModelsResponseSchema)` to create a new message.
 */
export const ListMaasCredentialModelsResponseSchema: GenMessage<ListMaasCredentialModelsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_maas, 11);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListMaasCredentialModelsData
 */
export type ListMaasCredentialModelsData = Message<"infinigence.infini.agentplatform.httpv2.ListMaasCredentialModelsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v2.MaasModel items = 1;
   */
  items: MaasModel[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListMaasCredentialModelsData.
 * Use `create(ListMaasCredentialModelsDataSchema)` to create a new message.
 */
export const ListMaasCredentialModelsDataSchema: GenMessage<ListMaasCredentialModelsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_maas, 12);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListMaasModelsRequest
 */
export type ListMaasModelsRequest = Message<"infinigence.infini.agentplatform.httpv2.ListMaasModelsRequest"> & {
  /**
   * 凭证记录 ID / Credential record ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListMaasModelsRequest.
 * Use `create(ListMaasModelsRequestSchema)` to create a new message.
 */
export const ListMaasModelsRequestSchema: GenMessage<ListMaasModelsRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_maas, 13);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListMaasModelsResponse
 */
export type ListMaasModelsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListMaasModelsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListMaasModelsData data = 4;
   */
  data?: ListMaasModelsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListMaasModelsResponse.
 * Use `create(ListMaasModelsResponseSchema)` to create a new message.
 */
export const ListMaasModelsResponseSchema: GenMessage<ListMaasModelsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_maas, 14);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListMaasModelsData
 */
export type ListMaasModelsData = Message<"infinigence.infini.agentplatform.httpv2.ListMaasModelsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v2.MaasModel items = 1;
   */
  items: MaasModel[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListMaasModelsData.
 * Use `create(ListMaasModelsDataSchema)` to create a new message.
 */
export const ListMaasModelsDataSchema: GenMessage<ListMaasModelsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_maas, 15);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CopyMaasCredentialKeyRequest
 */
export type CopyMaasCredentialKeyRequest = Message<"infinigence.infini.agentplatform.httpv2.CopyMaasCredentialKeyRequest"> & {
  /**
   * 凭证记录 ID / Credential record ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CopyMaasCredentialKeyRequest.
 * Use `create(CopyMaasCredentialKeyRequestSchema)` to create a new message.
 */
export const CopyMaasCredentialKeyRequestSchema: GenMessage<CopyMaasCredentialKeyRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_maas, 16);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CopyMaasCredentialKeyResponse
 */
export type CopyMaasCredentialKeyResponse = Message<"infinigence.infini.agentplatform.httpv2.CopyMaasCredentialKeyResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * 明文 API Key / Plaintext API key
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: string data = 4;
   */
  data: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CopyMaasCredentialKeyResponse.
 * Use `create(CopyMaasCredentialKeyResponseSchema)` to create a new message.
 */
export const CopyMaasCredentialKeyResponseSchema: GenMessage<CopyMaasCredentialKeyResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_maas, 17);

/**
 * 创建前预检：凭证名称租户下是否唯一。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.CheckMaasCredentialNameRequest
 */
export type CheckMaasCredentialNameRequest = Message<"infinigence.infini.agentplatform.httpv2.CheckMaasCredentialNameRequest"> & {
  /**
   * 待校验名称 / Name to check
   * @gotags: json:"name"
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CheckMaasCredentialNameRequest.
 * Use `create(CheckMaasCredentialNameRequestSchema)` to create a new message.
 */
export const CheckMaasCredentialNameRequestSchema: GenMessage<CheckMaasCredentialNameRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_maas, 18);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CheckMaasCredentialNameResponse
 */
export type CheckMaasCredentialNameResponse = Message<"infinigence.infini.agentplatform.httpv2.CheckMaasCredentialNameResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.CheckMaasCredentialNameData data = 4;
   */
  data?: CheckMaasCredentialNameData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CheckMaasCredentialNameResponse.
 * Use `create(CheckMaasCredentialNameResponseSchema)` to create a new message.
 */
export const CheckMaasCredentialNameResponseSchema: GenMessage<CheckMaasCredentialNameResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_maas, 19);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CheckMaasCredentialNameData
 */
export type CheckMaasCredentialNameData = Message<"infinigence.infini.agentplatform.httpv2.CheckMaasCredentialNameData"> & {
  /**
   * 名称是否可用（true = 未占用）/ true if available
   * @gotags: json:"available"
   *
   * @generated from field: bool available = 1;
   */
  available: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CheckMaasCredentialNameData.
 * Use `create(CheckMaasCredentialNameDataSchema)` to create a new message.
 */
export const CheckMaasCredentialNameDataSchema: GenMessage<CheckMaasCredentialNameData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_maas, 20);

/**
 * MaasCredentialHTTPV2Service MaaS 凭证 HTTP V2 服务 / MaaS credential HTTP V2 service
 *
 * @generated from service infinigence.infini.agentplatform.httpv2.MaasCredentialHTTPV2Service
 */
export const MaasCredentialHTTPV2Service: GenService<{
  /**
   * 创建 MaaS 凭证 / Create MaaS credential
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MaasCredentialHTTPV2Service.CreateMaasCredential
   */
  createMaasCredential: {
    methodKind: "unary";
    input: typeof CreateMaasCredentialRequestSchema;
    output: typeof CreateMaasCredentialResponseSchema;
  },
  /**
   * 获取 MaaS 凭证 / Get MaaS credential / 脱敏
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MaasCredentialHTTPV2Service.GetMaasCredential
   */
  getMaasCredential: {
    methodKind: "unary";
    input: typeof GetMaasCredentialRequestSchema;
    output: typeof GetMaasCredentialResponseSchema;
  },
  /**
   * 更新 MaaS 凭证 / Update MaaS credential
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MaasCredentialHTTPV2Service.UpdateMaasCredential
   */
  updateMaasCredential: {
    methodKind: "unary";
    input: typeof UpdateMaasCredentialRequestSchema;
    output: typeof UpdateMaasCredentialResponseSchema;
  },
  /**
   * 删除 MaaS 凭证 / Delete MaaS credential
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MaasCredentialHTTPV2Service.DeleteMaasCredential
   */
  deleteMaasCredential: {
    methodKind: "unary";
    input: typeof DeleteMaasCredentialRequestSchema;
    output: typeof DeleteMaasCredentialResponseSchema;
  },
  /**
   * 列出 MaaS 凭证 / List MaaS credentials
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MaasCredentialHTTPV2Service.ListMaasCredentials
   */
  listMaasCredentials: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListMaasCredentialsResponseSchema;
  },
  /**
   * 列出凭证可用模型（按 vendor+api_key 探测，不落库）/ List credential models (probe by vendor+api_key)
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MaasCredentialHTTPV2Service.ListMaasCredentialModels
   */
  listMaasCredentialModels: {
    methodKind: "unary";
    input: typeof ListMaasCredentialModelsRequestSchema;
    output: typeof ListMaasCredentialModelsResponseSchema;
  },
  /**
   * 列出指定凭证的可用模型 / List models for a specific credential
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MaasCredentialHTTPV2Service.ListMaasModels
   */
  listMaasModels: {
    methodKind: "unary";
    input: typeof ListMaasModelsRequestSchema;
    output: typeof ListMaasModelsResponseSchema;
  },
  /**
   * 复制凭证中的密钥 / Copy plaintext key of a credential
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MaasCredentialHTTPV2Service.CopyMaasCredentialKey
   */
  copyMaasCredentialKey: {
    methodKind: "unary";
    input: typeof CopyMaasCredentialKeyRequestSchema;
    output: typeof CopyMaasCredentialKeyResponseSchema;
  },
  /**
   * 校验凭证名称租户下是否唯一
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MaasCredentialHTTPV2Service.CheckMaasCredentialName
   */
  checkMaasCredentialName: {
    methodKind: "unary";
    input: typeof CheckMaasCredentialNameRequestSchema;
    output: typeof CheckMaasCredentialNameResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_agentplatform_httpv2_maas, 0);

